import { Store } from "@tanstack/react-store";
import type { ReactNode } from "react";

export type ToastType = "success" | "error" | "warning" | "info" | "pending";

export type ToastItem = {
  id: string;
  createdAt: number;

  type: ToastType;
  message: string;
  icon?: ReactNode;
  duration?: number;
  onClick?: () => void;
  onIgnore?: () => void;
};

const generateId = () => Math.random().toString(36).substring(2, 11);

export const toastsStore = new Store<ToastItem[]>([]);

export const addToast = (toast: Omit<ToastItem, "id" | "createdAt">) => {
  toastsStore.setState((state) => {
    const newToast = {
      ...toast,
      id: generateId(),
      createdAt: Date.now(),
    };

    return [newToast, ...state];
  });
};

export const removeToast = (id: string) => {
  toastsStore.setState((state) => state.filter((toast) => toast.id !== id));
};

export const clearToasts = () => {
  toastsStore.setState(() => []);
};
